var p2 = "/static/5d3b69274ff50579.png";

export { p2 as default };
//# sourceMappingURL=p_2.png.js.map
